;(function () {
  'use strict'

  angular
    .module('contrast.access-control-settings')
    .controller('AccessControlSettingsCtrl', [
      '$scope',
      '$translate',
      'dialogs',
      'AccessControlSettingsService'
    ])
})()
